import React, { useState } from 'react';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { SupervisoryInstitution } from '../../../../../api/types/settings/studies/supervisory-institution';
import dateUtils from '../../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { AddSupervisoryDialog } from './componenets/add-supervisory-dialog';
import { Button } from 'primereact/button';
import { deleteSupervisoryInstitutionOperation } from './operations/delete-supervisory-institution-operation';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { observer } from 'mobx-react-lite';

export const SettingsEducationSupervisoryInstitutionsTab = observer(() => {
  const [addSupervisory, setAddSupervisory] = useState(false);
  const [editInstitution, setEditInstitution] =
    useState<SupervisoryInstitution | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedInstitutions, setSelectedInstitutions] = useState<
    SupervisoryInstitution[]
  >([]);

  const [deleteInstitutionId, setDeleteInstitutionId] = useState<number | null>(
    null,
  );

  const handleDeleteInstitution = async (institutionId: number) => {
    await deleteSupervisoryInstitutionOperation(
      institutionId,
      setDeleteInstitutionId,
    );
  };

  const handleEditInstitution = (institution: SupervisoryInstitution) => {
    setEditInstitution(institution);
  };

  const handleSaveInstitution = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.SUPERVISORY_INSTITUTION,
      id,
      newName,
      setLoading,
    );
  };

  return (
    <div>
      <Button
        style={{ height: '30px' }}
        label={'להוספה'}
        onClick={() => setAddSupervisory(true)}
      />
      <Dialog
        header="הוספת גוף מפקח"
        visible={addSupervisory}
        onHide={() => setAddSupervisory(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddSupervisoryDialog onHide={() => setAddSupervisory(false)} />
      </Dialog>

      <EditTextDialog
        id={editInstitution?.id}
        value={editInstitution?.institutionName}
        title="עריכת גוף מפקח"
        label="שם הגוף המפקח"
        loading={loading}
        onSave={handleSaveInstitution}
        onHide={() => setEditInstitution(null)}
      />

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedInstitutions}
        onSelectionChange={(e) => setSelectedInstitutions(e.value)}
        value={globalSettingsStores.supervisoryInstitution}
        scrollable
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="institutionName"
          header="שם"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
        />

        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="createdByName"
          header="נוצר ע״י"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
        />

        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="createdAt"
          header="נוצר בתאריך"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(data: SupervisoryInstitution) => (
            <div>{dateUtils.displayFormatDate(data.createdAt)}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SupervisoryInstitution) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת גוף מפקח'}
                onClick={() => handleEditInstitution(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת גוף מפקח'}
                loading={deleteInstitutionId === data.id}
                disabled={deleteInstitutionId !== null}
                onClick={() => handleDeleteInstitution(data.id)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
